import gql from 'graphql-tag';
import { Component, Mixins, Prop, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import PaginationMixin from '../../PaginationMixin';
import LoginInformation from '../../types/login_information';
import Pager from '../shared/pager.vue';

@Component({ components: { Pager } })
export default class LibrariesList extends Vue {
  @Prop() public bookshopId!: string;
  @Getter public loginInformation?: LoginInformation;

  public readonly query = gql`
    query libraries($bookshopId: ID!) {
      librariesWithStatsForBookshop(bookshopId: $bookshopId) {
        activeLicenses
        library {
          name
          id
        }
      }
    }
  `;
}
